import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { ScreenContext } from '@/contexts/ScreenContext';
import Box, { BoxProps } from '@mui/material/Box';
import { ReactNode, useContext, useEffect, useState } from 'react';

type RwdSvgIconOwnProps = {
    landscapeIconSize: number; //px
    portraitIconSize: number; //px
    children: ReactNode;
    onClick?: () => void;
    isOnClickSound?: boolean;
    isOnPointerCursor?: boolean;
};

type RwdSvgIconProps = RwdSvgIconOwnProps & BoxProps;

export const RwdSvgIcon = (props: RwdSvgIconProps) => {
    const {
        landscapeIconSize,
        portraitIconSize,
        children,
        onClick,
        isOnClickSound = false,
        isOnPointerCursor = false,
        ...otherProps
    } = props;

    const { isLandscape, scaleFactor } = useContext(ScreenContext);
    const { playButtonAudio } = useContext(AudioPlayContext);

    const [rwdIconSize, setRwdIconSize] = useState<number>(1);

    useEffect(() => {
        setRwdIconSize(isLandscape ? landscapeIconSize : portraitIconSize);
    }, [isLandscape, scaleFactor]);

    const doOnClick = () => {
        if (onClick) {
            if (isOnClickSound) {
                playButtonAudio();
            }
            onClick();
        }
    };

    return (
        <Box
            width={`calc(${rwdIconSize} * 1px * ${scaleFactor})`}
            height={`calc(${rwdIconSize} * 1px * ${scaleFactor})`}
            display={'flex'}
            onClick={doOnClick}
            justifyContent={'center'}
            sx={{ cursor: isOnPointerCursor ? 'pointer' : 'default' }}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

export const RwdSvgIconInText = (props: RwdSvgIconProps) => {
    const {
        landscapeIconSize,
        portraitIconSize,
        children,
        onClick,
        isOnClickSound = false,
    } = props;

    const { isLandscape, scaleFactor } = useContext(ScreenContext);
    const { playButtonAudio } = useContext(AudioPlayContext);

    const [rwdIconSize, setRwdIconSize] = useState<number>(1);

    useEffect(() => {
        setRwdIconSize(isLandscape ? landscapeIconSize : portraitIconSize);
    }, [isLandscape, scaleFactor]);

    const doOnClick = () => {
        if (onClick) {
            if (isOnClickSound) {
                playButtonAudio();
            }
            onClick();
        }
    };

    return (
        <span
            style={{
                width: `calc(${rwdIconSize} * 1px * ${scaleFactor})`,
                height: `calc(${rwdIconSize} * 1px * ${scaleFactor})`,
                display: 'inline-block',
                verticalAlign: 'middle',
            }}
            onClick={doOnClick}
        >
            {children}
        </span>
    );
};
